import { render, staticRenderFns } from "./AllowNotifications.vue?vue&type=template&id=561e3216&scoped=true&"
import script from "./AllowNotifications.vue?vue&type=script&lang=js&"
export * from "./AllowNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AllowNotifications.vue?vue&type=style&index=0&id=561e3216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e3216",
  null
  
)

export default component.exports